module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-address-form"
  }, [_c('h2', {
    staticClass: "order-address-form__heading"
  }, [_vm._v("\n        Lieferadresse\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "order-address-form__form form-default"
  }, [_c('delivery-address', {
    ref: "deliveryAddress",
    attrs: {
      "disable-early-invoice": _vm.disableEarlyInvoice,
      "early-invoice-text": _vm.earlyInvoiceText,
      "firm-required": _vm.firmRequired,
      "comment-text": _vm.commentText
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "order-address-form__delivery"
  }, [_c('invoice-address', {
    ref: "invoiceAddress",
    attrs: {
      "firm-required": _vm.firmRequired
    }
  })], 1), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-address-form__form-group form-group"
  }, [_c('span', {
    staticClass: "order-address-form__required-hint"
  }, [_vm._v("\n                * Pflichtfeld\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6575b886","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Forms/Address.vue
// module id = 855
// module chunks = 0